<template>
  <IntNavButton color="tint" :full-border="true" :bold-text="true" @click="onAddRemoveButtonClick">
    <slot></slot>
    
    <svg xmlns="http://www.w3.org/2000/svg" width="18.996" height="17" viewBox="0 0 18.996 17" 
         :class="['inline-block relative w-[18px] h-4 ml-4 transition ease-out duration-500',
         productsInAnyWishlist() ? 'fill-blue stroke-blue' : 'fill-transparent stroke-stone-800 group-hover/button:stroke-blue group-hover/button:fill-blue']">
      <path d="M8.165,42.851a1.186,1.186,0,0,0,.84.349,1.2,1.2,0,0,0,.84-.349l6.594-6.594A5.3,5.3,0,0,0,9,28.708a5.3,5.3,0,0,0-7.446,7.538Z"
            transform="translate(0.5 -26.7)" stroke-width="1" />
    </svg>
  </IntNavButton>
</template>

<script>
  import { mapActions } from 'pinia'
  import { useWishlistStore } from '../../../../stores/wishlist'

  import EventBus from '../../../../bus'
  import Events from '../../events'
  
  import ProductQuantityUtil from '../../utils/product-quantity'
  
  import IntNavButton from '../../../nav-button'
  
  export default {
    name: 'IntWishlistButton',
    
    components: { IntNavButton },
    
    props: {
      productIds: { type: Array, required: true },
      collectionId: { type: Number, default: 0 },
      quantity: {
        type: Number,
        default: 1,
        validator: (value) => {
          return value !== null && value !== undefined && value !== '' && value > 0
        }
      }
    },
    
    methods: {
      ...mapActions(useWishlistStore, ['anyWishlistHasAllProducts']),

      onAddRemoveButtonClick() {
        const productsEvent = ProductQuantityUtil.createProductQuantityEvent(this.productIds, this.collectionId, this.quantity)
        EventBus.$emit(Events.addOrRemoveProducts, productsEvent)
      },

      productsInAnyWishlist() {
        return this.anyWishlistHasAllProducts(this.productIds)
      }
    }
  }
</script>